<template>
    <div class="row cart" v-if="!deleted">


        <div class="col-md-3">
            <img v-if="item.product.is_black_friday" class="express-delivery-cart doorbuster" src="/themes/rentone/assets/images/black-friday-badge.png">
            <img v-else-if="item.product.is_holiday_deal" class="express-delivery-cart doorbuster" src="/themes/rentone/assets/images/holiday-deals-sticker.png">
            <img v-else-if="item.product.is_express_delivery" class="express-delivery-cart" src="/themes/rentone/assets/images/express-delivery.svg">
            <img :src="item.product.images['248x248'][0]">
        </div>
        <div class="col-md-3">

            <a class="manufacturer" :href="item.product.url">{{ item.product.name }}</a>
            <p class="model">Model #{{ item.product.model }}</p>

            <div class="options">
                <li v-for="option, value in item.options.options">{{ option }}: {{ value }}</li>
            </div>
        </div>

        <div class="col-md-2">Quantity <input min="1" type="number" class="form-control qty" aria-label="quantity" v-model="quantity" @change="updateItem" ></div>

        <div class="col-md-3">
            <div class="input-group">
                <select class="custom-select" v-model="price"  @change="updateItem">
                    <option v-for="price in item.product.pricing" :value="price.id" v-if="price.active">{{ displayPrice(price) }}</option>
                </select>
            </div>

            <p class="RTOtotal">RTO Total: ${{ rtoTotal(item) }}</p>
            <p class="rentNowTotal" v-if="hasRentNowPricing()">*Rent Now Discount Applied at Checkout</p>
            <div class="updatebtn"><a @click.prevent="removeItem">remove</a></div>

            <div class="promobreakdown" v-if="hasAdjustment(item.rowId)">
                <p><strong>Promo Code: {{ formatPromoNames(adjustments[item.rowId].promos )}}</strong></p>
                <p>New Price: ${{ adjustments[item.rowId].rate }} for {{ adjustments[item.rowId].term }} {{ getPriceLabelPeriod(adjustments[item.rowId]) }}</p>
                <p>New RTO Total: ${{ adjustments[item.rowId].total }}</p>
                <p class="red">SAVINGS: ${{ adjustments[item.rowId].savings }}</p>

            </div>
        </div>

    </div>
</template>

<script>
    import {ServiceFactory} from '../../../../../../shared/assets/js/services/ServiceFactory';
    const CartService = ServiceFactory.get('cart');

    export default {
        data() {
            return {
                deleted: false,
                quantity: null,
                price: null,
            }
        },

        props: ['item', 'adjustments'],

        created() {
            this.quantity = this.item.qty;
            this.price = this.item.options.price_id;
        },

        methods: {

            displayPrice(price) {
                if (price.sale_amount > 0) {
                    return price.sale_formatted;
                }

                return price.formatted;
            },

            getPriceLabelPeriod(adjustment) {
                var label = adjustment.priceLabel.toLowerCase();
                if (label.indexOf('month') !== -1) {
                    return 'Months';
                }
                if (label.indexOf('week') !== -1) {
                    return 'Weeks';
                }

                return '';
            },

            hasAdjustment(rowId) {
                return this.adjustments[rowId] !== undefined;
            },

            formatPromoNames(promos) {
                return promos.toString()
            },

            rtoTotal(item) {
                return (item.price * item.options.payments).toFixed(2);
            },

            hasRentNowPricing() {
                const rentNowPrice = _.filter(this.item.product.pricing, (price) => price.label === 'Rent Now').pop();
                return rentNowPrice !== undefined && rentNowPrice.amount > 0;
            },

            async updateItem() {
                this.$emit('updating');
                await CartService.updateItem(this.item.rowId, this.price, this.quantity);
                this.$emit('refresh');
            },

            async removeItem() {
                this.$emit('updating');
                this.deleted = true;
                await CartService.deleteItem(this.item.rowId);
                this.$emit('refresh');
            }
        }
    }
</script>
